import React, { FC, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Input, Button, Modal, Row, Col } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import _ from "lodash";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "reducers/rootReducer";
import {MapTopics, SocketTopics} from "../../constants/enums"

const { TextArea } = Input;

const CameraVideoModal: FC<{
  onClose?: () => void;
  sensorObj?: any;
  socket?: ISocket
}> = ({ onClose, sensorObj, socket }) => {
  const [isModalVisible, setIsModalVisible] = useState<boolean>(true);
  const { rx } = useSelector((state: RootState) => state.dashboard);
  const [sensors, setSensors] = useState<any>([
    {
      sensor: 'personCount',
      count: 0,
      now: 0,
      timestamp: 0
    },
    {
      sensor: 'bicycleCount',
      count: 0,
      now: 0,
      timestamp: 0
    },
    {
      sensor: 'carCount',
      count: 0,
      now: 0,
      timestamp: 0
    },
    {
      sensor: 'airplaneCount',
      count: 0,
      now: 0,
      timestamp: 0
    },
    {
      sensor: 'busCount',
      count: 0,
      now: 0,
      timestamp: 0
    }
]);
  let interval: NodeJS.Timeout;

  const handleCancel = () => {
    setIsModalVisible(false);
    onClose && onClose();
  };

  const dispatch = useDispatch();
  const handleOk = () => {
    setIsModalVisible(false);
    onClose && onClose();
  };

  useEffect(() => {
    socket.subscribeToEvent(SocketTopics.SubscribePageTopics,  sensorObj.data.iotTopic);
    return () => {
      socket.unSubscribeToEvent(SocketTopics.UnSubscribePageTopics,  sensorObj.data.iotTopic);
    };
  }, []);

  useEffect(() => {
    if(rx && rx.dataset){
        let objects = Object.keys(rx.dataset);
        if(objects.length > 0){
          let data = [...sensors];
          objects.map((object) => {
            let index = sensors.findIndex((x)=>{
              return x.sensor === object;
            });
            if(index !== -1){
              data[index].count += rx.dataset[object];
              data[index].now = rx.dataset[object];
              data[index].timestamp = rx.timestamp;
            }
            else{
              data.push({
                sensor: object,
                count: rx.dataset[object],
                now: rx.dataset[object],
                timestamp: rx.timestamp,
              });
            }
          });
          setSensors(data);
        }
    }

  }, [rx]);

  return (
    <Modal
      title="Video analytics"
      visible={isModalVisible}
      onOk={handleOk}
      onCancel={handleCancel}
      width="1000px"
      className="beam-modal"
      footer={[]}
      destroyOnClose={true}
    >
      <Row className="custom-table mt-4">
        <Col span={24}>
          <Row className="header">
            <Col span={6}>Object</Col>
            <Col span={6}>Count</Col>
            <Col span={6}>Now</Col>
            <Col span={6}>Date & time</Col>
          </Row>
          {sensors.map((item, idx: number) => (
            <Row
              className="table-row d-flex"
              key={idx}
              style={{ alignItems: "baseline" }}
            >
              <Col span={3}>{item.sensor}</Col>
              <Col span={3}>{item.count}</Col>
              <Col span={3}>{item.now}</Col>
              <Col span={6}>{new Date(item.timestamp).toLocaleString()}</Col>
            </Row>
          ))}
        </Col>
      </Row>
    </Modal>
  );
};

export default CameraVideoModal;
